import type { AiAssistantHomeDto, AiAssistantHomeViewModel } from '../types/aiAssistant';

const demoAiAssistantHome: AiAssistantHomeDto = {
  greeting: '你好！我是峰峰，今天我们从薄弱点开始拆解。',
  prompts: [
    { id: 'geometry', title: '几何专项', subject: '数学', route_key: 'photo-search' },
    { id: 'mechanics', title: '力学专项', subject: '物理', route_key: 'photo-search' },
  ],
  fun_fact: {
    id: 'bee',
    title: '今日趣知',
    content: '蜜蜂会用舞蹈告诉同伴花蜜的方向和距离。',
  },
};

export const mapAiAssistantHomeDtoToViewModel = (
  dto: AiAssistantHomeDto
): AiAssistantHomeViewModel => ({
  greeting: dto.greeting?.trim() || '你好！我是峰峰，可以陪你讲题、批改和整理试卷。',
  prompts: (dto.prompts ?? []).map((prompt, index) => ({
    id: prompt.id || `assistant-prompt-${index + 1}`,
    title: prompt.title?.trim() || '专项练习',
    subject: prompt.subject?.trim() || '综合',
    routeKey: prompt.route_key,
  })),
  funFact: {
    id: dto.fun_fact?.id || 'fun-fact',
    title: dto.fun_fact?.title?.trim() || '今日趣知',
    content: dto.fun_fact?.content?.trim() || '完成一次追问后，我会把相关知识点整理给你。',
  },
});

export const getAiAssistantHome = async (): Promise<AiAssistantHomeViewModel> =>
  mapAiAssistantHomeDtoToViewModel(demoAiAssistantHome);
